// extracted by mini-css-extract-plugin
export default {"overlay":"SizesChartModal_overlay__8sKiq","container":"SizesChartModal_container__yzs61","close":"SizesChartModal_close__5-00x"};